import { useMutation } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { BulkCreateSignupCommandInput, BulkCreateSignupCommandOutput } from '@amzn/red-velvet-api';
import { useFeatures, getEnabledFeatures } from '../features';
import { getClient } from '../../utils/getClient';

const MUTATION_PREFIX = ['RedVelvetApi', 'bulkSignupCreate'];

export function useBulkCreateSignup(eventId: string) {
  const features = useFeatures();
  const [searchParams] = useSearchParams();
  const client = getClient(getEnabledFeatures(features, searchParams));

  return useMutation<BulkCreateSignupCommandOutput, Error, BulkCreateSignupCommandInput>({
    mutationKey: [...MUTATION_PREFIX, eventId],
    mutationFn: (input) => client.bulkCreateSignup(input),
  });
}
